module.exports = __webpack_public_path__ + "img/1.f0520ee4.png";